/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
  if (sessionStorage.getItem("header_main_menu") == '1') {
    
    $(document).find('.choose-menu').removeClass('active-menu');
    $(document).find('.choose-1').addClass('active-menu');
    
    $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
    $(document).find('.homepage-banner-info-wrap').css('display','none');
    $(document).find('.choose-menu-image-1').addClass('active-menu-banner');

	$(document).find('.header-menu-1').css('display','block');
    $(document).find('.header-menu-2').css('display','none');
    $(document).find('.header-menu-3').css('display','none');
    $(document).find('.header-menu-4').css('display','none');
    $(document).find('.header-menu-5').css('display','none');
    $(document).find('.header-menu-6').css('display','none');
  } else if (sessionStorage.getItem("header_main_menu") == '2') {
    
    $(document).find('.choose-menu').removeClass('active-menu');
    $(document).find('.choose-2').addClass('active-menu');
    
    $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
    $(document).find('.homepage-banner-info-wrap').css('display','none');
    $(document).find('.choose-menu-image-2').addClass('active-menu-banner');

	$(document).find('.header-menu-2').css('display','block');
    $(document).find('.header-menu-1').css('display','none');
    $(document).find('.header-menu-3').css('display','none');
    $(document).find('.header-menu-4').css('display','none');
    $(document).find('.header-menu-5').css('display','none');
    $(document).find('.header-menu-6').css('display','none');
  } else if (sessionStorage.getItem("header_main_menu") == '3') {

    $(document).find('.choose-menu').removeClass('active-menu');
    $(document).find('.choose-3').addClass('active-menu');
    
    $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
    $(document).find('.homepage-banner-info-wrap').css('display','none');
    $(document).find('.choose-menu-image-3').addClass('active-menu-banner');

    $(document).find('.header-menu-3').css('display','block');
    $(document).find('.header-menu-1').css('display','none');
    $(document).find('.header-menu-2').css('display','none');
    $(document).find('.header-menu-4').css('display','none');
    $(document).find('.header-menu-5').css('display','none');
    $(document).find('.header-menu-6').css('display','none');
  } else if (sessionStorage.getItem("header_main_menu") == '4') {

    $(document).find('.choose-menu').removeClass('active-menu');
    $(document).find('.choose-4').addClass('active-menu');
    
    $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
    $(document).find('.homepage-banner-info-wrap').css('display','none');
    $(document).find('.choose-menu-image-4').addClass('active-menu-banner');

    $(document).find('.header-menu-4').css('display','block');
    $(document).find('.header-menu-1').css('display','none');
    $(document).find('.header-menu-2').css('display','none');
    $(document).find('.header-menu-3').css('display','none');
    $(document).find('.header-menu-5').css('display','none');
    $(document).find('.header-menu-6').css('display','none');
  } else if (sessionStorage.getItem("header_main_menu") == '5') {

    $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
    $(document).find('.homepage-banner-info-wrap').css('display','none');
    $(document).find('.choose-menu-image-5').addClass('active-menu-banner');
    
    $(document).find('.choose-menu').removeClass('active-menu');
    $(document).find('.choose-5').addClass('active-menu');

    $(document).find('.header-menu-5').css('display','block');
    $(document).find('.header-menu-1').css('display','none');
    $(document).find('.header-menu-2').css('display','none');
    $(document).find('.header-menu-3').css('display','none');
    $(document).find('.header-menu-4').css('display','none');
    $(document).find('.header-menu-6').css('display','none');
  }

  else if (sessionStorage.getItem("header_main_menu") == '6') {

    $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
    $(document).find('.homepage-banner-info-wrap').css('display','none');
    $(document).find('.choose-menu-image-6').addClass('active-menu-banner');

    $(document).find('.choose-menu').removeClass('active-menu');
    $(document).find('.choose-6').addClass('active-menu');
    
    $(document).find('.black-menu-logo').css('display','none');
    $(document).find('.white-menu-logo').css('display','block');

    $(document).find('.header-menu-6').css('display','block');
    $(document).find('.header-menu-1').css('display','none');
    $(document).find('.header-menu-2').css('display','none');
    $(document).find('.header-menu-3').css('display','none');
    $(document).find('.header-menu-4').css('display','none');
    $(document).find('.header-menu-5').css('display','none');
  }

});


$('.choose-1').click(function(e) {
  sessionStorage.setItem('header_main_menu', '1');
  
  $(document).find('.black-menu-logo').css('display','block');
  $(document).find('.white-menu-logo').css('display','none');

  $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
  $(document).find('.homepage-banner-info-wrap').css('display','none');
  $(document).find('.choose-menu-image-1').addClass('active-menu-banner');

  $(document).find('.choose-menu').removeClass('active-menu');
  $(this).addClass('active-menu');

  $(document).find('.header-menu-1').css('display','block');
  $(document).find('.header-menu-2').css('display','none');
  $(document).find('.header-menu-3').css('display','none');
  $(document).find('.header-menu-4').css('display','none');
  $(document).find('.header-menu-5').css('display','none');
  $(document).find('.header-menu-6').css('display','none');
});

$('.choose-2').click(function(e) {
  sessionStorage.setItem('header_main_menu', '2');
  
  $(document).find('.black-menu-logo').css('display','block');
  $(document).find('.white-menu-logo').css('display','none');

  $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
  $(document).find('.homepage-banner-info-wrap').css('display','none');
  $(document).find('.choose-menu-image-2').addClass('active-menu-banner');

  $(document).find('.choose-menu').removeClass('active-menu');
  $(this).addClass('active-menu');
  
  $(document).find('.header-menu-2').css('display','block');
  $(document).find('.header-menu-1').css('display','none');
  $(document).find('.header-menu-3').css('display','none');
  $(document).find('.header-menu-4').css('display','none');
  $(document).find('.header-menu-5').css('display','none');
  $(document).find('.header-menu-6').css('display','none');
});

$('.choose-3').click(function(e) {
  sessionStorage.setItem('header_main_menu', '3');
  
  $(document).find('.black-menu-logo').css('display','block');
  $(document).find('.white-menu-logo').css('display','none');

  $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
  $(document).find('.homepage-banner-info-wrap').css('display','none');
  $(document).find('.choose-menu-image-3').addClass('active-menu-banner');

  $(document).find('.choose-menu').removeClass('active-menu');
  $(this).addClass('active-menu');

  $(document).find('.header-menu-3').css('display','block');
  $(document).find('.header-menu-1').css('display','none');
  $(document).find('.header-menu-2').css('display','none');
  $(document).find('.header-menu-4').css('display','none');
  $(document).find('.header-menu-5').css('display','none');
  $(document).find('.header-menu-6').css('display','none');
});

$('.choose-4').click(function(e) {
  sessionStorage.setItem('header_main_menu', '4');

  $(document).find('.black-menu-logo').css('display','block');
  $(document).find('.white-menu-logo').css('display','none');

  $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
  $(document).find('.homepage-banner-info-wrap').css('display','none');
  $(document).find('.choose-menu-image-4').addClass('active-menu-banner');

  $(document).find('.choose-menu').removeClass('active-menu');
  $(this).addClass('active-menu');

  $(document).find('.header-menu-4').css('display','block');
  $(document).find('.header-menu-1').css('display','none');
  $(document).find('.header-menu-2').css('display','none');
  $(document).find('.header-menu-3').css('display','none');
  $(document).find('.header-menu-5').css('display','none');
  $(document).find('.header-menu-6').css('display','none');
});

$('.choose-5').click(function(e) {
  sessionStorage.setItem('header_main_menu', '5');

  $(document).find('.black-menu-logo').css('display','block');
  $(document).find('.white-menu-logo').css('display','none');
  
  $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
  $(document).find('.homepage-banner-info-wrap').css('display','none');
  $(document).find('.choose-menu-image-5').addClass('active-menu-banner');

  $(document).find('.choose-menu').removeClass('active-menu');
  $(this).addClass('active-menu');

  $(document).find('.header-menu-5').css('display','block');
  $(document).find('.header-menu-1').css('display','none');
  $(document).find('.header-menu-2').css('display','none');
  $(document).find('.header-menu-3').css('display','none');
  $(document).find('.header-menu-4').css('display','none');
  $(document).find('.header-menu-6').css('display','none');
});

$('.choose-6').click(function(e) {
  sessionStorage.setItem('header_main_menu', '6');

  $(this).find('.black-menu-logo').css('display','none');
  $(this).find('.white-menu-logo').css('display','block');

  $(document).find('.homepage-banner-info-wrap').removeClass('active-menu-banner');
  $(document).find('.homepage-banner-info-wrap').css('display','none');
  $(document).find('.choose-menu-image-6').addClass('active-menu-banner');

  $(document).find('.choose-menu').removeClass('active-menu');
  $(this).addClass('active-menu');

  $(document).find('.header-menu-6').css('display','block');
  $(document).find('.header-menu-1').css('display','none');
  $(document).find('.header-menu-2').css('display','none');
  $(document).find('.header-menu-3').css('display','none');
  $(document).find('.header-menu-4').css('display','none');
  $(document).find('.header-menu-5').css('display','none');
});